"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.useAccountHookFactory = void 0;
var types_1 = require("../types");
var middle_end_1 = require("@genoa/middle-end");
var utils_1 = require("../utils");
function deriveAccountStatus(_a) {
    var _b = _a.data, customer = _b.customer, biller_connection = _b.biller_connection;
    if (biller_connection.status === types_1.BillerConnectionStatus.PAUSED) {
        return middle_end_1.AccountStates.PAUSED;
    }
    else if (customer.identity_status === types_1.IdentityStatus.CANCELED ||
        customer.identity_status === types_1.IdentityStatus.DELETED) {
        return middle_end_1.AccountStates.CANCELED;
    }
    return middle_end_1.AccountStates.ACTIVE;
}
function useAccountHookFactory(useQueryHook, useAuthStateHook, useQueryOptions) {
    var _a, _b, _c, _d;
    if (useQueryOptions === void 0) { useQueryOptions = {}; }
    var _e = useAuthStateHook(), uid = _e.uid, isAnonymous = _e.isAnonymous;
    var query = useQueryHook({ customerId: uid }, __assign(__assign({}, useQueryOptions), { skip: useQueryOptions.skip || !uid || isAnonymous }));
    var data = (_a = query.data) === null || _a === void 0 ? void 0 : _a.data;
    var billerConnection = data === null || data === void 0 ? void 0 : data.biller_connection;
    var relinkingBillerConnection = data === null || data === void 0 ? void 0 : data.relinking_biller_connection;
    return __assign(__assign({}, query), { isUnhandledError: query.isError &&
            (('status' in query.error && query.error.status !== 401 && query.error.status !== 200) ||
                ((0, utils_1.isApiError)(query.error) && ((_d = (_c = (_b = query.error) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.code) !== types_1.AccountErrorCode.AccountNotFound) ||
                'stack' in query.error), billerConnection: billerConnection, relinkingBillerConnection: relinkingBillerConnection, customer: data === null || data === void 0 ? void 0 : data.customer, isAccountLoaded: query.isError || query.isSuccess, derivedStatus: query.data ? deriveAccountStatus(query.data) : undefined, isActive: (billerConnection === null || billerConnection === void 0 ? void 0 : billerConnection.offer_status) === types_1.OfferStatus.ACCEPTED, isOnboarding: (billerConnection === null || billerConnection === void 0 ? void 0 : billerConnection.offer_status) === types_1.OfferStatus.ONBOARDING, connectionBillerAccountPublicId: (relinkingBillerConnection === null || relinkingBillerConnection === void 0 ? void 0 : relinkingBillerConnection.biller_account_public_id) || (billerConnection === null || billerConnection === void 0 ? void 0 : billerConnection.biller_account_public_id) });
}
exports.useAccountHookFactory = useAccountHookFactory;
